import { Component, Injector } from '@angular/core';
import { HolidayScheduleService, GlobalRegionService } from '../../ve.service';
import { BaseGridComponent } from '../base-grid/base-grid.component';
import { CgpConfirmationDialogService } from '../../../../shared/cgp-confirmation-dialog/cgp-confirmation-dialog.service';
import { CgpSnackbarService } from '../../../../shared/cgp-snackbar/cgp-snackbar.service';
import { Validators } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { FilterableService } from '../../../../shared/filterable-service';


@Component({
  selector: 'app-holiday-schedule',
  templateUrl: '../base-grid/base-grid.component.html',
})
export class HolidayScheduleComponent extends BaseGridComponent {
  private readonly globalRegionService: GlobalRegionService;
  private readonly globalRegionFilterableService = new FilterableService();


  constructor(
    cgpConfirmationDialogService: CgpConfirmationDialogService,
    cgpSnackbarService: CgpSnackbarService,
    service: HolidayScheduleService,
    injector: Injector,
  ) {
    super(cgpConfirmationDialogService, cgpSnackbarService, service, injector);
    this.globalRegionService = injector.get(GlobalRegionService);
    this.appCardTitle = 'Holiday Schedules';
    this.path = '/?activeOnly=false';

    this.columns = [
      {
        field: 'GlobalRegionDescription',
        title: 'Global Region',
        type: 'dropdown',
        service: this.globalRegionFilterableService,
        textField: 'Description',
        valueField: 'Id',
        name: 'GlobalRegionId',
        refreshSecondaryData: this.populateGlobalRegionsList,
      },
      {
        field: 'HolidayDate',
        title: 'Date',
        type: 'date',
        name: 'HolidayDate',
        filter: 'date'
      },

    ];

   this.editForm = this.formBuilder.group({
    Id: [],
    GlobalRegionId: ['', Validators.required],
    GlobalRegionDescription: [],
    HolidayDate: ['', Validators.required],
    AuditDto: [],

    });
  }

  populateGlobalRegionsList(dataItem: any) {
    dataItem.globalRegionService.read()
    .then(result => {
      if (result.length > 0) {
        result.sort((a, b) => a.Description.localeCompare(b.Description));
      }
      dataItem.globalRegionFilterableService.next(result);
    });

  }
}
